import { useMutation } from '@tanstack/react-query'
import {
  exportTransactions,
  ExportTransactionsParams,
} from '@/queries/transactions/queries.ts'

type UseExportTransactionsOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useExportTransactions = (
  options?: UseExportTransactionsOptions
) => {
  return useMutation({
    mutationFn: (params: ExportTransactionsParams) =>
      exportTransactions(params),
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
